import React from 'react'

import { TextField ,Grid, Typography} from "@mui/material"
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import BooleanFilter from '../../core/form/BooleanFilter';
import { useSelector, useDispatch } from 'react-redux';
import { setStitchingtaskFilterCriteria } from 'store/slice/ManufSlice';

export default function StitchingtaskFilterCriteriaImpl() {
    const dispatch = useDispatch();
    const {filterCriteria} = useSelector((state)=>state.manufslice.stitchingtaskDashboard);
        
    const {mfstitchingstatusList} = useSelector((state)=>state.manufslice);    
    const {mfproductList} = useSelector((state)=>state.manufslice);    
    const {workerList} = useSelector((state)=>state.manufslice);
    
const updateTitleCriteria = (title) =>{
        dispatch(setStitchingtaskFilterCriteria(
            {
                ...filterCriteria,
                title:title
        }))
    }
const updateOrderidCriteria = (orderid) =>{
        dispatch(setStitchingtaskFilterCriteria(
            {
                ...filterCriteria,
                orderid:orderid
        }))
    }
const updateProductnameCriteria = (productname) =>{
        dispatch(setStitchingtaskFilterCriteria(
            {
                ...filterCriteria,
                productname:productname
        }))
    }
const updateWorkernameCriteria = (workername) =>{
        dispatch(setStitchingtaskFilterCriteria(
            {
                ...filterCriteria,
                workername:workername
        }))
    }

    return (

        <Grid container justifyContent="space-between" direction="row" lg={12} >
                    <Grid item lg={3} xs={3}>
                        <TextField 
                            label="Orderid"
                            name="orderid"
                            value={filterCriteria.orderid}
                            onChange={(e)=>updateOrderidCriteria(e.target.value)}
                            sx={{width:'100%'}}
                        />
                    </Grid>

                    <Grid item lg={4} xs={4}>
                        <TextField
                            label="Productname"
                            name="productname"
                            value={filterCriteria.productname}
                            onChange={(e)=>updateProductnameCriteria(e.target.value)}
                            sx={{width:'100%'}}
                        />
                    </Grid>

                    <Grid item lg={4} xs={4}>
                        <TextField 
                            label="Workername"
                            name="workername"
                            value={filterCriteria.workername}
                            onChange={(e)=>updateWorkernameCriteria(e.target.value)}
                            sx={{width:'100%'}}
                        />
                    </Grid>


        </Grid>
    )

}